import Oidc from 'oidc-client'
import axios from 'axios'
import UsersService from '@/services/UsersService'
import { changeLocalization } from '@/i18n'
import AppConfig from '@/mixins/AppConfig-APP_TARGET';

export default new class AuthenticationService {

  userManager
  isAuthenticated = false
  userProfile
  localUserProfile

  constructor() {
    var config = {
      authority: process.env.VUE_APP_AUTH_SERVERURL,
      client_id: 'loopRepFrontend',
      redirect_uri: `${window.location.origin}${process.env.BASE_URL}callback`,
      response_type: 'id_token token',
      scope: 'openid profile email loopRepBackend',
      post_logout_redirect_uri : window.location.origin,
    };

    this.userManager = new Oidc.UserManager(config);
  }

  getUser() {
    return this.userManager.getUser().then(user => {
      if (user) {
        this.userProfile = user.profile;
        axios.defaults.headers.common['Authorization'] = "Bearer " + user.access_token;

        // Get user profile data from backend
        return UsersService.getUserProfile().then(response => {
          if (response.data) {
            this.isAuthenticated = true;
            this.localUserProfile = response.data;

            return changeLocalization(this.localUserProfile.LocalizationId);
          } else {
            return this.userManager.removeUser().then(() => {
              return Promise.reject('unauthorized');
            });
          }
        }).catch((e) => {
          // If backend returns 401, the access token is probably expired --> sign in again
          if (e && e.response && e.response.status == 401)
            return this.userManager.signinRedirect();
          else
            return Promise.reject(e);
        });
      }
      else {
        this.isAuthenticated = false; 
        this.userProfile = null;
      }
    });
  }

  login(login_hint) {
    return this.getUser().then(() => {
      if (!this.isAuthenticated)
        if (login_hint)
          return this.userManager.signinRedirect({ login_hint : login_hint });
        else
          return this.userManager.signinRedirect();
    });
  }

  callback() {
    return this.userManager.signinRedirectCallback().then(() => {
      return this.getUser();
    }).catch((e) => {
      this.isAuthenticated = false; 
      this.userProfile = null;
      console.error(e);
      return Promise.reject(e);
    });
  }

  logout()  {
    return this.userManager.signoutRedirect();
  }

  get isMSMUser() {
    return this.localUserProfile.UserType === 'M';
  }

  get authorizationHeader() {
    return { Authorization: axios.defaults.headers.common.Authorization };
  }

  get logoExternalImageUrl() {
    let retVal = process.env.BASE_URL + 'static/img/msm_loop_logo_40px.png';

    if (this.localUserProfile.LogoExternalImageId && (AppConfig.methods.isDemo() || !this.isMSMUser)) {
      retVal = process.env.BASE_URL + `api/media/image?id=${this.localUserProfile.LogoExternalImageId}`;
    }

    return retVal;
  }
}